var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightAlt = function SvgArrowRightAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-right-alt_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-right-alt_svg__arrow-right-alt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.01 11H5c-.55 0-1 .45-1 1s.45 1 1 1h11.01v1.79c0 .45.54.67.85.35l2.78-2.79c.19-.2.19-.51 0-.71l-2.78-2.79c-.31-.32-.85-.09-.85.35z",
    className: "arrow-right-alt_svg__vector"
  }))));
};
export { SvgArrowRightAlt as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5BcnJvdyBSaWdodCBBbHQ8L3RpdGxlPjxnIGNsYXNzPSJhcnJvdy1yaWdodC1hbHQiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE2LjAxIDExSDVjLS41NSAwLTEgLjQ1LTEgMXMuNDUgMSAxIDFoMTEuMDF2MS43OWMwIC40NS41NC42Ny44NS4zNWwyLjc4LTIuNzljLjE5LS4yLjE5LS41MSAwLS43MWwtMi43OC0yLjc5Yy0uMzEtLjMyLS44NS0uMDktLjg1LjM1VjExWiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";